function truncateMarkdown(markdown: string | null | undefined, threshold: number, ellipses?: boolean): string
{
	if (!markdown)
	{
		console.log('No markdown provided to truncateMarkdown');
		return '';
	}

	if (typeof markdown !== 'string')
	{
		console.log('Markdown is not a string:', markdown);
		return '';
	}

	if (!threshold || threshold <= 0)
	{
		return markdown;
	}

	//If the markdown is shorter than the threshold, return it as is
	if (markdown.length <= threshold)
	{
		return markdown;
	}

	//Find the last space before the threshold
	const pre = markdown.slice(0, threshold);
	const post = markdown.slice(threshold);
	const lastSpaceIndex = pre.lastIndexOf(' ');

	//Fall back to the threshold if no space was found
	if (lastSpaceIndex === -1)
	{
		return pre;
	}

	let result = markdown.slice(0, lastSpaceIndex);

	//We also need to handle unclosed italics + bold.
	//const formatterRegex = /(?<=[^*])\*+(?=[^*])/g;
	const formatterRegex = /\*+/g; // Simplified regex to match all asterisk sequences

	const matches = result.matchAll(formatterRegex);
	const matchesArray = Array.from(matches);
	const count = matchesArray.length;

	//If there's an odd number of asterisks, we need to close the formatting
	if (count % 2 === 1)
	{
		const last = matchesArray[count - 1][0];
		result += last; // since we captured the last match, we can just add the corresponding closing asterisk(s)
	}

	//We also need to handle unclosed links.
	/*const unfinishedLink = /(?<!\[)[^\[\]]*\][^\(\)]*\([^()]*\)/g
	const unfinishedLinkMatches = unfinishedLink.exec(post);

	if(unfinishedLinkMatches)
	{
		console.log('Unfinished link:', unfinishedLinkMatches);

		//Close the link:
		result += ')';
	}*/

	if (ellipses)
	{
		result += '...';
	}

	return result;
}

export default truncateMarkdown;
